(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["playecom-portal-nav"] && !Shopify.designMode) return;
  try {
    if (!window.playecomNavigationBound) {
  window.playecomNavigationBound = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-pe-navigation][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-pe-navigation][open]').forEach((menu) => {
      if (event.target.closest('a') || !menu.contains(event.target)) menu.open = false;
    });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["playecom-video-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pe-video')) {
  customElements.define('pe-video', class extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._initialMarkup = this.innerHTML;
      this.bindTrigger();
    }
    bindTrigger() {
      const trigger = this.querySelector('button');
      const template = this.querySelector('template');
      if (!trigger || !template) return;
      trigger.addEventListener('click', () => {
        if (!template.content.querySelector('iframe,video')) return;
        this.replaceChildren(template.content.cloneNode(true));
        const media = this.querySelector('iframe,video');
        media?.focus();
        if (media instanceof HTMLVideoElement) media.play().catch(() => {});
      }, { once: true });
    }
    stop() {
      if (!this.querySelector('iframe,video') || !this._initialMarkup) return;
      this.innerHTML = this._initialMarkup;
      this.bindTrigger();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
